import { memo } from 'react';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import * as S from './style';

interface IProps {
  title?: string | React.ReactNode;
}

const ModalTitle = ({ title }: IProps) => (
  <S.ModalTitle className="modal-title">
    <Title level={1}>{title}</Title>
  </S.ModalTitle>
);

export default memo(ModalTitle);
